import React, { useEffect, useRef, useState, useImperativeHandle } from 'react';
import { isMobileFun, isSafari } from '../../utils/obj-utils';
import './style.scss';
import temp from '../../temp/config';
export default function index(props) {
  const { fields } = props;
  const isMobile = isMobileFun();
  const [meauscroll, setMeauscroll] = useState(true);
  const [Safari, setSafari] = useState(false);
  const id = props?.params?.pagename;
  const [isApp, setIsapp] = useState(0);
  // sectionAction
  useImperativeHandle(props.eventRef, () => {
    if (props.eventRef) {
      return {
        sendEvent
      };
    }
  });
  const sendEvent = () => {
    window.Dmp.sectionAction(id);
    window.navigationIndex = props.fields.navigationIndex.value;
    window.navigationPagename = window.navigationPagenameb = id !== undefined ? id : '';
    if (document.querySelector('.FooterFixmeau_v1')) {
      if (window.navigationPagename !== 'home' && window.navigationPagename !== 'choose' && window.navigationPagename !== 'order') {
        document.querySelector('.FooterFixmeau_v1').style.display = 'flex';
      } else {
        document.querySelector('.FooterFixmeau_v1').style.display = 'none';
      }
    }
  };
  const scroll = () => {
    const t = document.documentElement.scrollTop || document.body.scrollTop;
    setMeauscroll(!(t >= 60));
    onresize();
  };
  const onresize = () => {
    if (isMobile) {
      var height = 0;
      if (isSafari()) {
        if (document.querySelector('.Header_v1')) {
          height = document.querySelector('.Header_v1').getBoundingClientRect().height;
        }
        var winheight = (window.innerHeight - height) * 0.91;
      } else {
        if (document.querySelector('.Header_v1')) {
          height = document.querySelector('.Header_v1').getBoundingClientRect().height;
        }
        var winheight = window.innerHeight - height;
      }
      document.getElementById('OpentionIframe').style.height = winheight + 'px';
    }
  };
  useEffect(() => {
    if (isSafari()) {
      setSafari(true);
    } else {
      setSafari(false);
    }

    var load = document.createElement('div');
    load.id = 'OpentionLoading';
    if (document.getElementById('OpentionLoading')) {
      document.getElementById('OpentionLoading').remove();
    }
    if (document.getElementById(id)) {
      document.getElementById(id).appendChild(load);
    }
    if (window.location.href.indexOf('app/vehicles/') !== -1) {
      setIsapp(1);
      membermessageOpention('');
    } else {
      if (window.attachEvent) {
        window.attachEvent('message', function (event) {
          membermessageOpention(event);
          window.detachEvent('message');
        });
      } else if (window.addEventListener) {
        window.addEventListener(
          'message',
          function (event) {
            membermessageOpention(event);
          },
          { once: true }
        );
      }
    }
    onresize();
    window.addEventListener('scroll', scroll);
    return () => {
      window.removeEventListener('scroll', scroll);
    };
  }, []);

  var eventJson;
  function membermessageOpention(event) {
    console.log(event);
    if (event.data && event.data?.landed !== undefined) {
      eventJson = event.data;
      if (event.data.landed) {
        if (eventJson.userToken) {
          getOpentionIframe(eventJson.userToken);
        } else {
          getOpentionIframe();
        }
      } else {
        getOpentionIframe();
      }
    } else {
      getOpentionIframe();
    }
  }
  function getOpentionIframe(userToken) {
    let mallurl = fields?.mallurl?.value ? JSON.parse(fields?.mallurl?.value + '') : '';
    if (mallurl) {
      if (userToken) {
        document.getElementById('OpentionIframe').setAttribute('src', `${mallurl?.[temp.app.term]}&token=${userToken}`);
      } else {
        document.getElementById('OpentionIframe').setAttribute('src', `${mallurl?.[temp.app.term]}`);
      }
    }

    if (document.getElementById('OpentionLoading')) {
      document.getElementById('OpentionLoading').remove();
    }
  }

  return (
    <div className={`OpentionBox ${!meauscroll ? 'active' : ''} ${isApp === 1 ? 'appUse' : ''}`} id={id}>
      <iframe
        id="OpentionIframe"
        className="OpentionIframe"
        src=""
        width="100%"
        height="100%"
        frameBorder="0"
        scrolling="auto‌"
        // sandbox="allow-same-origin allow-scripts"
      />
      {Safari && (
        <div
          className={`${Safari ? 'safari-fix' : 'safari-hide'}`}
          onClick={() => {
            let mallurl = fields?.mallurl?.value ? JSON.parse(fields?.mallurl?.value) : '';
            if (isSafari() && mallurl) {
              window.open(`${mallurl?.[temp.app.term]}`);
              if (mallurl.dmp) {
                window.Dmp.clickAction(mallurl.dmp, mallurl?.[temp.app.term]);
              }
            }
          }}
        ></div>
      )}
    </div>
  );
}
